import { render, staticRenderFns } from "./AppConfigIndex.vue?vue&type=template&id=2d06daf0&scoped=true&lang=pug"
import script from "./AppConfigIndex.vue?vue&type=script&lang=js"
export * from "./AppConfigIndex.vue?vue&type=script&lang=js"
import style0 from "./AppConfigIndex.vue?vue&type=style&index=0&id=2d06daf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06daf0",
  null
  
)

export default component.exports